import React, { useState } from 'react';
import { Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { useOnceReveal } from '@common/hooks';

import { GetFittingModelList_pdp_base_info_fitting_model_list_item_list as Model } from '../graphql/fitting-model-list_types.2';

interface ModelItemProps {
  model: Model;
}

export const ModelItem: React.FC<React.PropsWithChildren<ModelItemProps>> = ({ model }) => {
  const { targetRef, isRevealed } = useOnceReveal();

  const [displayImagePlaceHolder, setDisplayImageHolder] = useState(true);

  const hidePlaceHolder = () => {
    setDisplayImageHolder(false);
  };

  const showPlaceHolder = () => {
    setDisplayImageHolder(true);
  };

  return (
    <Item ref={targetRef}>
      <Images>
        {isRevealed && <Image src={model.profile_image_url} onLoad={hidePlaceHolder} onError={showPlaceHolder} />}
        {displayImagePlaceHolder && <ImagePlaceHolder />}
      </Images>
      <Info>
        <Flex>
          <Name variant='Body_16_Multiline_SemiBold' color='textPrimary'>
            {model.name}
          </Name>
          {model.badge?.label && (
            <Label variant='Caption_9_Medium' color='textPrimary'>
              {model.badge.label}
            </Label>
          )}
        </Flex>
        <BodyInfo>
          <Text as='span' variant='Caption_12_Multiline_Medium' color='textTertiary'>
            {model.size_text_list.map((item, index) => (
              <span key={`${item}-${index}`}>{item}</span>
            ))}
          </Text>
        </BodyInfo>
        {model.fitting_size_list && (
          <WearInfo>
            <Text as='span' variant='Body_14_Multiline_Medium' color='textSecondary'>
              {model.fitting_size_list.map((size) => `${size} 착용`).join(', ')}
            </Text>
          </WearInfo>
        )}
      </Info>
    </Item>
  );
};

const Item = styled.div`
  padding: 12px 0;
  display: flex;
`;

const Info = styled.div``;

const Flex = styled.div`
  display: flex;
  align-items: center;
`;
const Name = styled(Text)``;

const Label = styled(Text)`
  margin-left: 3px;
  padding: 0 4px;
  height: 14px;
  line-height: 14px;
  color: ${vars.v3Color.staticWhite};
  background-color: ${vars.v3Color.pink400};
  border-radius: 2px;
`;

const BodyInfo = styled.div`
  span::after {
    content: '';
    display: inline-block;
    margin: 0 3px;
    width: 2px;
    height: 2px;
    background-color: ${vars.v3Color.gray200};
    vertical-align: middle;
  }
  span:last-of-type::after {
    display: none;
  }
`;

const WearInfo = styled.div`
  margin-top: 6px;
  word-break: break-all;
`;

const Images = styled.div`
  margin: 0 16px 0 0;
  position: relative;
  width: 48px;
  height: 48px;
`;

const Image = styled.img`
  width: 48px;
  height: 48px;
  border: 1px solid ${vars.v3Color.gray150};
  border-radius: 24px;

  &[src=''] {
    visibility: hidden;
  }
`;

const ImagePlaceHolder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 48px;
  height: 48px;
  border-radius: 24px;
  background-color: ${vars.v3Color.gray100};
`;
